import { useState, useEffect, useCallback } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export const usePageData = (slug) => {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const response = await fetch(`${API_URL}/api/pages/${slug}`);
        if (response.ok) {
          const data = await response.json();
          setPageData(data);
        } else {
          setError('Page not found');
        }
      } catch (err) {
        if (process.env.NODE_ENV === 'development') {
          console.error('Failed to fetch page:', err);
        }
        setError('Failed to load page');
      } finally {
        setLoading(false);
      }
    };
    
    if (slug) {
      fetchPage();
    }
  }, [slug]);

  return { pageData, loading, error };
};

export const useContentPage = (slug) => {
  const { pageData, loading, error } = usePageData(slug);
  return { page: pageData, loading, error };
};
